import { useMemo } from 'react';
import { useAuth } from '../../auth/useAuth';
import { usePermissions } from '../../../shared/hooks/usePermissions';
import { useTickets } from './useTickets';
import { badgeForTickets } from '../lib/support';

export function useSupportBadges(): { count: number } {
  const { currentUser } = useAuth();
  const { hasPermission } = usePermissions();
  const { tickets } = useTickets();
  const uid = currentUser?.uid ?? '';
  const isManager = hasPermission('MANAGE_SUPPORT_TICKETS');
  const count = useMemo(() => badgeForTickets(tickets, uid, isManager), [tickets, uid, isManager]);
  return { count };
}
